module.exports = __webpack_public_path__ + "img/PPMPprint2.c4684ade.png";